@if (title) {
    <div class="t2-semi-bold c-primary-gray-900">{{ title | translate }}</div>
}
<div class="groups-grid w-100"
     [class.mt-24]="!!title"
     [style.grid-template-columns]="'repeat(' + (attachments?.length ?? 0) + ', 1fr)'">
    @for (attachment of attachments ?? []; track attachment) {
        <div fxLayout="column" fxLayoutAlign="start start">
            <div class="t4">{{ attachment.documentType }}</div>
            <div class="files-grid w-100 mt-16">
                @for (file of attachment.files; track file) {
                    <af-file-preview [file]="file"/>
                }
            </div>
        </div>
    }
</div>
@if (showDownloadAll) {
    <div fxLayout="row" fxLayoutAlign="start center" class="mt-16">
        <ui-kit-button icon="ic_download"
                       iconPosition="left"
                       type="text"
                       [spinnerId]="spinnerId"
                       (clickListener)="downloadAll()"
                       [removePadding]="true"
                       [label]="'i18n_af_buttonDownloadAllDocuments' | translate"/>
    </div>
}
